import React, { useEffect, useState } from 'react'
import { getProductPrice } from '../../network/ProductPrices'
import { useParams } from 'react-router-dom'
import { Form, Row, Col, notification, PageHeader, Card, Table } from 'antd'

const ViewProductPrices = ({ history }) => {
  const [productData, setProductData] = useState(null)
  const [pricing, setPricing] = useState([])
  const [adjustments, setAdjustments] = useState([])
  const [currency, setCurrency] = useState('')
  const [form] = Form.useForm()
  const { key, storeId } = useParams()

  useEffect(() => {
    getProductPrice(key, storeId)
      .then((data) => {
        const product = data.list.product
        if (data.list.currency) {
          switch (data.list.currency) {
            case 'eur':
              setCurrency(' (in euros)')
              break
            case 'usd':
              setCurrency(' (in dollars)')
              break
            case 'gbp':
              setCurrency(' (in pounds)')
              break
            case 'cny':
              setCurrency(' (in yuan)')
              break
            case 'jpy':
              setCurrency(' (in yen)')
              break
            case 'aud':
              setCurrency(' (in Australian dollars)')
              break
            case 'cad':
              setCurrency(' (in Canadian dollars)')
              break
            case 'chf':
              setCurrency(' (in Swiss francs)')
              break
            case 'hkd':
              setCurrency(' (in Hong Kong dollars)')
              break
            case 'nzd':
              setCurrency(' (in New Zealand dollars)')
              break
            default:
              setCurrency('')
          }
        }
        if (product) {
          setProductData(product)
          // Ensure pricing items have keys for table rendering
          const pricingWithKeys = (product.pricing || []).map(
            (item, index) => ({
              ...item,
              key: item.key || `pricing_${index}_${Date.now()}`,
            })
          )
          setPricing(pricingWithKeys)

          // Ensure adjustment items have keys for table rendering
          const adjustmentsWithKeys = (product.adjustments || []).map(
            (item, index) => ({
              ...item,
              key: item.key || `adjustment_${index}_${Date.now()}`,
            })
          )
          setAdjustments(adjustmentsWithKeys)
        } else {
          notification.error({ message: 'Product not found!' })
        }
      })
      .catch((error) => {
        console.error('Failed to fetch product prices:', error)
        notification.error({ message: 'Error fetching product prices!' })
      })
  }, [key, storeId, form])

  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => history.push('/product-prices')}
        title={`Pricing for ${productData?.label || ''}`}
      />
      <Row style={{ padding: '24px' }}>
        <Col span={24}>
          <Form form={form} layout="vertical">
            <Card
              title={`Pricing ${currency}`}
              style={{ marginBottom: '24px' }}
            >
              <Table
                dataSource={pricing.map((item, index) => ({
                  ...item,
                  index,
                }))}
                columns={[
                  {
                    title: 'Label',
                    dataIndex: 'label',
                    key: 'label',
                    width: '50%',
                  },
                  {
                    title: 'Price',
                    dataIndex: 'price',
                    key: 'price',
                    width: '50%',
                    render: (text) => text || 'N/A',
                  },
                ]}
                pagination={false}
                rowKey="key"
                locale={{
                  emptyText: 'No pricing items available for this product.',
                }}
              />
            </Card>

            {adjustments.length > 0 && (
              <Card title="Adjustments">
                <Table
                  dataSource={adjustments.map((item, index) => ({
                    ...item,
                    index,
                  }))}
                  columns={[
                    {
                      title: 'Label',
                      dataIndex: 'label',
                      key: 'label',
                      width: '50%',
                    },
                    {
                      title: 'Price',
                      dataIndex: 'price',
                      key: 'price',
                      width: '50%',
                      render: (text) => text || 'N/A',
                    },
                  ]}
                  pagination={false}
                  rowKey="key"
                  locale={{
                    emptyText:
                      'No adjustment items available for this product.',
                  }}
                />
              </Card>
            )}
          </Form>
        </Col>
      </Row>
    </>
  )
}

export default ViewProductPrices
